import React, { useEffect, useState } from 'react';
import BRAND_LOGO from '../assets/anns-logo.png';

export default function LoadingScreen({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1800);
    const doneTimer = setTimeout(() => onDone(), 2400);
    return () => { clearTimeout(fadeTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <div className={`loading-screen${fading ? ' loading-screen--out' : ''}`}>
      <div className="loading-screen__inner">
        <img
          src="anns-logo.png"
          alt="ANN'S"
          className="loading-screen__logo"
          onError={e => { e.target.style.display = 'none'; }}
        />
        <h1 className="loading-screen__name">ANN'S</h1>
        <p className="loading-screen__sub">Beauty Parlour</p>
        <div className="loading-screen__dots">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
}
